import cn from 'classnames';
import './styles.scss';

interface CouponTabsPillProps {
	name?: string;
	text: string;
	onClick: () => void;
	isActive: boolean;
	className?: string;
	disabled?: boolean;
	cyTestRef?: string;
}

const CouponTabsPill = ({ name, className, text, isActive, onClick, disabled, cyTestRef }: CouponTabsPillProps) => {
	return (
		<button
			name={name}
			onClick={onClick}
			className={cn(`couponTabsPill ${className}`, {
				'couponTabsPill--active': isActive,
				'couponTabsPill--disabled': disabled,
			})}
			disabled={disabled}
			data-cy={cyTestRef}
		>
			{text}
		</button>
	);
};

export default CouponTabsPill;
